<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('child_reports.application_report') }}</h4>
        </template>
        <template v-slot:body>
              <b-row>
                <b-col lg="12" sm="12" md="12">
                  <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                      <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset">
                          <b-overlay>
                              <b-row>
                                  <b-col lg="6" sm="12" md="4">
                                      <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="">
                                          <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="fiscal_year_id "
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                              {{$t('globalTrans.fiscal_year')}}
                                              </template>
                                              <b-form-select
                                              plain
                                              v-model="search.fiscal_year_id"
                                              id="fiscal_year_id"
                                              :options="fiscalYearList"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              >
                                              <template v-slot:first>
                                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                              </b-form-select>
                                              <div class="invalid-feedback">
                                                  {{ errors[0] }}
                                              </div>
                                          </b-form-group>
                                      </ValidationProvider>
                                  </b-col>
                                  <b-col lg="6" sm="12">
                                      <ValidationProvider name="Organization" vid="org_id" rules="">
                                          <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="organiation_id"
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                                  {{$t('globalTrans.organization')}}
                                              </template>
                                              <b-form-select
                                              plain
                                              v-model="search.org_id"
                                              :options="orgList"
                                              id="organiation_id"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              >
                                              <template v-slot:first>
                                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                              </b-form-select>
                                              <div class="invalid-feedback">
                                              {{ errors[0] }}
                                              </div>
                                          </b-form-group>
                                      </ValidationProvider>
                                  </b-col>
                                  <b-col lg="6" sm="12">
                                      <ValidationProvider name="Institute Type" vid="office_type_id" rules="">
                                          <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="office_type_id"
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                                  {{$t('legal_institute_management.institute_type')}}
                                              </template>
                                              <b-form-select
                                              plain
                                              v-model="search.office_type_id"
                                              :options="officeTypeList"
                                              id="office_type_id"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              >
                                              <template v-slot:first>
                                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                              </b-form-select>
                                              <div class="invalid-feedback">
                                              {{ errors[0] }}
                                              </div>
                                          </b-form-group>
                                      </ValidationProvider>
                                  </b-col>
                                  <b-col lg="6" sm="12">
                                      <ValidationProvider name="Institute Name" vid="office_id" rules="">
                                          <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="office_id"
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                                  {{$t('legal_institute_management.institute_name')}}
                                              </template>
                                              <b-form-select
                                              plain
                                              v-model="search.office_id"
                                              :options="officeList"
                                              id="office_id"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              >
                                              <template v-slot:first>
                                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                              </b-form-select>
                                              <div class="invalid-feedback">
                                              {{ errors[0] }}
                                              </div>
                                          </b-form-group>
                                      </ValidationProvider>
                                  </b-col>
                                  <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                                      <b-button type="submit" variant="primary">{{ $t('globalTrans.report') }}</b-button>
                                  </b-col>
                              </b-row>
                          </b-overlay>
                      </b-form>
                  </ValidationObserver>
                </b-col>
              </b-row>
        </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
            <template v-slot:body>
                <b-row v-if="loaded">
                    <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                            <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                            <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                            <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                            <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                            <div class="titleDiv">
                              <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('child_reports.legal_resident_summary_report') }}</span><br>
                            </div>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" class="mt-4 text-right">
                        <b-button-group>
                            <b-button @click="pdfExport" variant="success" class="mr-2">{{  $t('globalTrans.export_pdf') }}</b-button>
                            <!-- <a
                              style="color: black"
                              title="Excel"
                              class="btn btn-xs btn-warning mr-6 float-right"
                              :href="`${childServiceBaseUrl}reports/legal-resident-summary-report/excel-export/${search.fiscal_year_id}/${search.org_id}/${search.office_type_id}/${search.office_id}/${$i18n.locale}/${search.fis_start_date}/${search.fis_end_date}`"
                              target="_blank"
                            >
                              {{ $t('globalTrans.export_excel') }}
                          </a> -->
                        </b-button-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                      <b-row>
                        <b-col xs="12" sm="12" md="6" class="text-left">
                            <div v-if="titleData.org_name" class="text-dark"><b>{{ $t('globalTrans.organization') }} </b>: {{ titleData.org_name }}</div>
                            <span v-if="titleData.institute_type_name" class="text-center text-dark"><b>{{ $t('legal_institute_management.institute_type') }} </b>: {{ titleData.institute_type_name }}</span>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" class="text-right">
                            <div v-if="titleData.institute_name" class="text-dark"><b>{{ $t('legal_institute_management.institute_name') }} </b>: {{ titleData.institute_name }}</div>
                            <span v-if="titleData.year" class="text-center text-dark"><b>{{ $t('globalTrans.fiscal_year') }} </b>: {{ titleData.year }}</span>
                        </b-col>
                      </b-row>
                    </b-col>
                </b-row>
                <b-overlay :show="unitLoad">
                    <b-row>
                        <!-- <b-col lg="12" xs="12" md="12"> -->
                            <b-table-simple responsive="true" bordered style="width: 100%; font-size:11px">
                                <b-thead>
                                    <b-tr class="bg-none">
                                        <b-th rowspan="2" style="vertical-align: top">{{ $t('rehabilitation_management.institute_name') }}</b-th>
                                        <b-th rowspan="2" style="vertical-align: top">{{ $t('child_reports.current_resident') }}</b-th>
                                        <b-th colspan="2" style="vertical-align: top">{{ $t('child_reports.age_wise_resident') }}</b-th>
                                        <b-th colspan="2" style="vertical-align: top">{{ $t('child_reports.case_type_wise_resident') }}</b-th>
                                        <b-th colspan="2" style="vertical-align: top">{{ $t('child_reports.pending_or_detention_resident') }}</b-th>
                                        <b-th colspan="2" style="vertical-align: top">{{ $t('child_reports.staying_time_wise_resident') }}</b-th>
                                        <b-th colspan="3" style="vertical-align: top">{{ $t('child_reports.court_attendance_wise_resident') }}</b-th>
                                        <b-th rowspan="2" style="vertical-align: top">{{ $t('production_store.comment') }}</b-th>
                                    </b-tr>
                                    <b-tr>
                                        <b-th width="10%">{{ $t('globalTrans.age') + ' (' + $t('globalTrans.year') + ')' }}</b-th>
                                        <b-th>{{ $t('globalTrans.number') }}</b-th>
                                        <b-th>{{ $t('child_reports.case_type') }}</b-th>
                                        <b-th>{{ $t('globalTrans.number') }}</b-th>
                                        <b-th>{{ $t('child_reports.pending_or_detained') }}</b-th>
                                        <b-th>{{ $t('globalTrans.number') }}</b-th>
                                        <b-th>{{ $t('child_reports.staying_time') }}</b-th>
                                        <b-th>{{ $t('globalTrans.number') }}</b-th>
                                        <b-th>{{ $t('child_reports.attendance_in_court') }}</b-th>
                                        <b-th>{{ $t('globalTrans.number') }}</b-th>
                                        <b-th>{{ $t('child_reports.reasons_not_attending') }}</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody v-if="Object.values(report_data).length > 0">
                                    <b-tr style="font-weight: bold; color: magenta;">
                                        <b-td class="text-center">{{ $n(1) }}</b-td>
                                        <b-td class="text-center">{{ $n(2) }}</b-td>
                                        <b-td class="text-center">{{ $n(3) }}</b-td>
                                        <b-td class="text-center">{{ $n(4) }}</b-td>
                                        <b-td class="text-center">{{ $n(5) }}</b-td>
                                        <b-td class="text-center">{{ $n(6) }}</b-td>
                                        <b-td class="text-center">{{ $n(7) }}</b-td>
                                        <b-td class="text-center">{{ $n(8) }}</b-td>
                                        <b-td class="text-center">{{ $n(9) }}</b-td>
                                        <b-td class="text-center">{{ $n(10) }}</b-td>
                                        <b-td class="text-center">{{ $n(11) }}</b-td>
                                        <b-td class="text-center">{{ $n(12) }}</b-td>
                                        <b-td class="text-center">{{ $n(13) }}</b-td>
                                        <b-td class="text-center">{{ $n(14) }}</b-td>
                                    </b-tr>
                                    <b-tr v-for="item in maxLength" :key="item">
                                        <b-td v-if="item == 1" :rowspan="maxLength">{{ getOfficeNameById(report_data.office_info.office_id) }}</b-td>
                                        <b-td v-if="item == 1" :rowspan="maxLength">{{ $n(report_data.currentResident) }}</b-td>
                                        <b-td v-if="item == 1">{{ $t('child_reports.under_nine') }}</b-td>
                                        <b-td v-else-if="item == 2">{{ $t('child_reports.nine_years_to_ten') }}</b-td>
                                        <b-td v-else-if="item == 3">{{ $t('child_reports.ten_years_to_twelve') }}</b-td>
                                        <b-td v-else-if="item == 4">{{ $t('child_reports.twelve_years_to_sixteen') }}</b-td>
                                        <b-td v-else-if="item == 5">{{ $t('child_reports.sixteen_years_to_eighteen') }}</b-td>
                                        <b-td v-else-if="item == 6">{{ $t('child_reports.above_eighteen') }}</b-td>
                                        <b-td v-else-if="item == 7">{{ $t('child_reports.no_mention_age') }}</b-td>
                                        <b-td v-else-if="item == 8" :rowspan="maxLength - 7"></b-td>
                                        <b-td v-if="item == 1">{{ report_data.underNine ? $n(Object.keys(report_data.underNine).length) : $n(0) }}</b-td>
                                        <b-td v-else-if="item == 2">{{ report_data.nineToTen ? $n(Object.keys(report_data.nineToTen).length) : $n(0) }}</b-td>
                                        <b-td v-else-if="item == 3">{{ report_data.tenToTwelve ? $n(Object.keys(report_data.tenToTwelve).length) : $n(0) }}</b-td>
                                        <b-td v-else-if="item == 4">{{ report_data.twelveToSixteen ? $n(Object.keys(report_data.twelveToSixteen).length) : $n(0) }}</b-td>
                                        <b-td v-else-if="item == 5">{{ report_data.sixteenToEigthteen ? $n(Object.keys(report_data.sixteenToEigthteen).length) : $n(0) }}</b-td>
                                        <b-td v-else-if="item == 6">{{ report_data.aboveEighteen ? $n(Object.keys(report_data.aboveEighteen).length) : $n(0) }}</b-td>
                                        <b-td v-else-if="item == 7">{{ report_data.notAge ? $n(report_data.notAge) : $n(0) }}</b-td>
                                        <b-td v-else-if="item == 8" :rowspan="maxLength - 7"></b-td>
                                        <b-td>
                                          {{ (Object.keys(report_data.caseTypeWise)[item - 1]) ? getCaseTypeName(Object.keys(report_data.caseTypeWise)[item - 1]) : '' }}
                                        </b-td>
                                        <b-td>
                                          {{ (Object.values(report_data.caseTypeWise).length) >= item ? $n(Object.values(report_data.caseTypeWise)[item - 1].length) : '' }}
                                        </b-td>
                                        <b-td>
                                          {{ (Object.keys(report_data.caseStatusWise)[item - 1]) ? getCaseStatusName(Object.keys(report_data.caseStatusWise)[item - 1]) : '' }}
                                        </b-td>
                                        <b-td>
                                          {{ (Object.values(report_data.caseStatusWise).length) >= item ? $n(Object.values(report_data.caseStatusWise)[item - 1].length) : '' }}
                                        </b-td>
                                        <b-td>
                                          {{ (Object.keys(report_data.tenureTimeWise)[item - 1]) ? getTenureTimeName(Object.keys(report_data.tenureTimeWise)[item - 1]) : '' }}
                                        </b-td>
                                        <b-td>
                                          {{ (Object.values(report_data.tenureTimeWise).length) >= item ? $n(Object.values(report_data.tenureTimeWise)[item - 1].length) : '' }}
                                        </b-td>
                                        <b-td v-if="item == 1">
                                          <span v-if="Object.values(report_data.attendanceDate).length !== 0">
                                            <div v-for="(value, date) in report_data.attendanceDate" :key="date">
                                              {{ date | dateFormat }}
                                            </div>
                                          </span>
                                          <span v-else></span>
                                        </b-td>
                                        <b-td v-else-if="item == 2" :rowspan="maxLength - 1"></b-td>
                                        <b-td v-if="item == 1">{{ report_data.attendanceCount ? $n(report_data.attendanceCount) : 0 }}</b-td>
                                        <b-td v-else-if="item == 2" :rowspan="maxLength - 1"></b-td>
                                        <b-td v-if="item == 1">
                                          <span v-if="Object.values(report_data.attendanceDate).length == 0 && report_data.attendanceCount == 0">
                                              {{ $t('child_reports.noAttendance') }}
                                          </span>
                                          <span v-else></span>
                                        </b-td>
                                        <b-td v-else-if="item == 2" :rowspan="maxLength - 1"></b-td>
                                        <b-td v-if="item == 1" :rowspan="maxLength">{{ $t('child_reports.comment_msg') }}</b-td>
                                    </b-tr>
                                </b-tbody>
                                <b-tbody v-if="nodata">
                                    <b-tr>
                                      <b-td colspan="13" class="text-center">{{ $t('globalTrans.noDataFound') }}</b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                    </b-row>
                </b-overlay>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { legalResidentSummaryReportApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ExportPdf from './export-pdf_details'
import ReportHeading from '@/Utils/report-head'
import excel from 'vue-excel-export'
import Vue from 'vue'
Vue.use(excel)

export default {
  mixins: [RouteBasedList],
  components: {
  },
  data () {
    return {
          childServiceBaseUrl: childServiceBaseUrl,
          nodata: true,
          maxLength: 0,
          unitLoad: false,
          search: {
              fiscal_year_id: 0,
              org_id: 0,
              office_type_id: 0,
              office_id: 0,
              fis_start_date: 0,
              fis_end_date: 0
          },
          titleData: {
              year: '',
              org_name: '',
              institute_type_name: '',
              institute_name: ''
          },
          editItemId: 0,
          officeTypeList: [],
          officeList: [],
          report_data: {},
          rows: [],
          reportHeadData: '',
          loaded: false
        }
  },
  computed: {
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeTypeList()
       this.getOrgName()
      } else {
        this.titleData.org_name = ''
      }
      this.report_data = {}
      this.nodata = true
    },
    'search.office_type_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeList()
       this.getOfficeTypeName()
      } else {
        this.titleData.institute_type_name = ''
      }
      this.report_data = {}
      this.nodata = true
    },
    'search.office_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeName()
      } else {
        this.titleData.institute_name = ''
      }
      this.report_data = {}
      this.nodata = true
    },
    'search.fiscal_year_id': function (newVal, oldVal) {
      if (newVal !== 0) {
          this.fiscalYearDateRange(newVal)
      } else {
          this.search.fis_start_date = ''
          this.search.fis_end_date = ''
          this.titleData.year = ''
      }
      this.report_data = {}
      this.nodata = true
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.org_id) {
                this.getOfficeTypeList()
                this.getOrgName()
            }
            if (this.search.office_type_id) {
                this.getOfficeList()
                this.getOfficeTypeName()
            }
            if (this.search.office_id) {
                this.getOfficeName()
            }
            if (this.search.fiscal_year_id) {
              this.getFiscalYear()
            }
            this.headerName()
        }
    }
  },
  created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
    this.headerName()
  },
  mounted () {
  },
  methods: {
    getCaseTypeName (Id) {
      const Case = this.$store.state.ChildService.commonObj.caseTypeList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return Case.text_bn
        } else {
            return Case.text_en
        }
    },
    getCaseStatusName (Id) {
      const Case = this.$store.state.ChildService.commonObj.caseStatusList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return Case.text_bn
        } else {
            return Case.text_en
        }
    },
    getTenureTimeName (Id) {
      const Case = this.$store.state.ChildService.commonObj.tenureTimeList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return Case.text_bn
        } else {
            return Case.text_en
        }
    },
    fiscalYearDateRange (id) {
        const Dated = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
        this.search.fis_start_date = Dated.start_date
        this.search.fis_end_date = Dated.end_date
        this.getFiscalYear()
    },
    getFiscalYear () {
        const Year = this.$store.state.commonObj.fiscalYearList.find(item => item.value === this.search.fiscal_year_id)
        if (this.$i18n.locale === 'bn') {
            this.titleData.year = Year.text_bn
        } else {
            this.titleData.year = Year.text_en
        }
    },
    searchData () {
      this.loadData()
    },
    getOrgName () {
      const Org = this.$store.state.commonObj.organizationProfileList.find(item => item.status === 0 && item.value === this.search.org_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.org_name = Org.text_bn
      } else {
          this.titleData.org_name = Org.text_en
      }
    },
    getOfficeTypeName () {
      const Org = this.$store.state.commonObj.officeTypeList.find(item => item.status === 0 && item.value === this.search.office_type_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.institute_type_name = Org.text_bn
      } else {
          this.titleData.institute_type_name = Org.text_en
      }
    },
    getOfficeName () {
      const Org = this.$store.state.commonObj.officeList.find(item => item.status === 0 && item.value === this.search.office_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.institute_name = Org.text_bn
      } else {
          this.titleData.institute_name = Org.text_en
      }
    },
    getOfficeNameById (Id) {
      const Office = this.$store.state.commonObj.officeList.find(item => item.status === 0 && item.value === parseInt(Id))
      if (this.$i18n.locale === 'bn') {
          return Office.text_bn
      } else {
          return Office.text_en
      }
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value)).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    loadData () {
      this.unitLoad = true
      const params = Object.assign({}, this.search)
      RestApi.getData(childServiceBaseUrl, legalResidentSummaryReportApi, params).then(response => {
        if (response.success) {
            this.report_data = response.data
            if (Object.keys(this.report_data.caseTypeWise).length > 7) {
              this.maxLength = Object.keys(this.report_data.caseTypeWise).length
            } else {
              this.maxLength = 7
            }
            this.nodata = false
            this.unitLoad = false
        } else {
          this.maxLength = 0
          this.unitLoad = false
          this.report_data = {}
          this.nodata = true
        }
      })
    },
    async headerName () {
       const headdata = await ReportHeading.getReportHead(childServiceBaseUrl, 'configuration/report-heading/detail', 2)
       this.reportHeadData = headdata
       this.loaded = true
    },
   pdfExport () {
      const reportTitle = this.$t('child_reports.application_report')
      ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 2, reportTitle, this.report_data, this, this.titleData)
    }
  }
}
</script>
<style scoped>
.reportTitle {
  font-weight: bold;
    border: 1px solid;
    padding: 8px 15px 8px 15px;
    border-radius: 11px;
}
.titleDiv {
  margin-top: 1.2rem;
  font-size: 18px;
}
/* .myRow td {
    padding: 0px !important;
}
.myRow td div {
    padding: 5px;
    border-bottom: 1px solid #dee2e6;
} */
</style>
